<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To my Beloved Heavenly Father, to the Person of the Holy Spirit, to my Assigned Scribe Angels, and lastly, to my best friend, my personal Lord and Saviour, Jesus. Thank you all for the love, inspiration, support, guidance, and grace. I couldn’t have done it without you. Thank you from my heart.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?a9604e88